export const corporate = {
  "hero": {
    "title": "Over EZELREIZEN",
    "subtitle": "Ontdek ons ​​verhaal, onze visie en het gepassioneerde team dat woningruil opnieuw uitvindt voor de meest veeleisende verhuurders."
  },
  "mission": {
    "badge": "Onze missie",
    "title": "Democratisering van premium peer-to-peer-reizen",
    "description": "DONKEY TRAVEL is opgericht met een eenvoudige ambitie: om ook de beste gasten te laten genieten van de vruchten van hun werk. Wij zijn van mening dat eigenaren van uitzonderlijke woningen met een beoordeling van 4,5 en hoger een speciaal platform verdienen waar ze hun eigendommen met vertrouwen kunnen verhandelen, zonder de financiële wrijving van traditionele verhuur."
  },
  "philosophy": {
    "badge": "Filosofie & Waarden",
    "title": "In het hart van onze club",
    "description": "We zijn niet alleen een platform, we zijn een gemeenschap gebouwd op vertrouwen, wederzijds respect en uitstekende gastvrijheid.",
    "values": {
      "fair": {
        "title": "Eigen vermogen",
        "desc": "Ons handelssysteem is ontworpen om eerlijk en transparant te zijn. U biedt tijd aan in uw accommodatie, u bespaart tijd om te reizen. Het is eenvoudig, zonder verborgen kosten."
      },
      "local": {
        "title": "Onderdompeling",
        "desc": "Woningruil is de kans om als een local te leven, regio’s buiten de gebaande paden te ontdekken en authentieke verbindingen te creëren."
      },
      "community": {
        "title": "Vertrouwen",
        "desc": "Door onze club te reserveren voor gasten met een beoordeling van 4,5+ garanderen wij een onberispelijk niveau van eisen en kwaliteit binnen ons netwerk."
      }
    }
  },
  "team": {
    "badge": "Het team",
    "title": "Achter EZELTRAVEL",
    "subtitle": "Een platform geboren uit een passie voor reizen en hospitality.",
    "members": {
      "ceo": {
        "name": "Sylvain",
        "role": "Oprichter & CEO",
        "bio": "Sylvain, al jaren een gepassioneerde gastheer, stelde zich DONKEY TRAVEL voor, op zoek naar een oplossing om gratis te reizen en tegelijkertijd zijn eigen accommodatie te promoten. Gedreven door de wens om de beste Europese uitwisselingsclub op te richten, zorgt hij elke dag voor de uitmuntendheid van de gemeenschap."
      }
    }
  },
  "investors": {
    "badge": "Investeerders & Partners",
    "title": "Ga mee op avontuur",
    "description": "DONKEY TRAVEL groeit en we staan ​​altijd open voor strategische kansen om onze ontwikkeling in heel Europa te versnellen.",
    "cta": "Neem contact met ons op"
  }
};
